<template>
  <div class="car-gallery">
    <div class="car-gallery__container">
      <div class="car-gallery__info">
        <div class="car-gallery__title" v-html="domainConfig.gallery.title"> </div>
        <div class="car-gallery__desc" v-html="domainConfig.gallery.content"></div>
        <div class="car-gallery__button" @click="gotoAll">
          <div class="car-gallery__button-text">Get Started</div>
          <img src="@/assets/arrow_outward_white.svg" class="car-gallery__icon" alt="">
        </div>
      </div>

      <div class="car-gallery__gallery">
        <!-- 三张拼接的车辆图片 -->
        <div class="car-gallery__gallery-image car-gallery__gallery-image--left">
          <img :src="domainConfig.galleryImages?.left || require('../assets/car-gallery-left.png')"
            alt="" class="car-gallery__gallery-img">
        </div>
        <div class="car-gallery__gallery-image car-gallery__gallery-image--center">
          <img
            :src="domainConfig.galleryImages?.center || require('../assets/car-gallery-center.png')"
            alt="" class="car-gallery__gallery-img">
        </div>
        <div class="car-gallery__gallery-image car-gallery__gallery-image--right">
          <img
            :src="domainConfig.galleryImages?.right || require('../assets/car-gallery-right.png')"
            alt="" class="car-gallery__gallery-img">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'CarGallery',
  computed: {
    ...mapGetters({
      deviceType: 'deviceType',
      domainConfig: 'domainConfig'
    })
  },
  methods: {
    // 跳转到全部车辆页面
    gotoAll () {
      // 获取当前路由的channel参数
      const currentChannel = this.$router.currentRoute.params.channel;

      // 如果存在channel参数，则构建带channel的路径
      if (currentChannel) {
        // 构建完整URL
        const baseUrl = window.location.origin;
        // 直接获取当前URL的查询字符串，包括?前缀
        const fullQueryString = window.location.search;
        const fullPath = `${baseUrl}/${currentChannel}/car-list${fullQueryString}`;

        // 使用location跳转
        window.location.href = fullPath;
      } else {
        // 没有channel参数，使用常规router跳转
        this.$router.push({
          path: '/car-list'
        });
      }
    }
  }
}
</script>

<style lang="scss" >
@import '~@/css/variables.scss';

.car-gallery {
	background: #ffffff;
	padding: rem(50) rem(120);

	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	align-self: stretch;
	position: relative;

	&__container {
		width: 100%;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		border-radius: rem(12);
		overflow: hidden;
		position: relative;
		gap: rem(32);
	}

	&__info {
		display: flex;
		flex-direction: column;
		gap: rem(20);
		width: rem(460);
		z-index: 2;
	}

	&__title {
		color: #050b20;

		font-size: rem(24);
		line-height: rem(32);
		font-weight: 700;
	}

	&__desc {
		color: #555;

		font-size: rem(14);
		line-height: rem(22);
	}

	&__button {
		display: flex;
		flex-direction: row;
		align-items: center;
		gap: rem(10);
		background: #405ff2;
		border-radius: rem(8);
		padding: rem(14) rem(24);
		width: fit-content;
		cursor: pointer;
	}

	&__button-text {
		color: #fff;

		font-size: rem(14);
		font-weight: 700;
	}

	&__icon {
		width: rem(12);
		height: rem(12);
		filter: brightness(0) invert(1);
	}

	&__gallery {
		display: flex;
		flex-direction: row;
		width: 100%;
		height: rem(308);
		overflow: hidden;
		gap: rem(32);
		flex: 1;
	}

	&__gallery-image {
		flex: 1;
		height: 100%;
		overflow: hidden;
		position: relative;
		border-radius: rem(12);
		background: #ec407a;
	}

	&__gallery-img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		object-position: center;
	}
}

// 响应式样式 - PC设备
.detect_deviece_pc,
.detect_deviece_desktop {
	.car-gallery {
		--fontsize-base: #{$vw_fontsize_pc};
		font-size: calc(var(--fontsize-base) / #{$vw_design_pc} * 100vw);
	}
}

// 响应式样式 - 移动设备
.detect_deviece_mobile {
	.car-gallery {
		--fontsize-base: #{$vw_fontsize_mobile};
		font-size: calc(var(--fontsize-base) / #{$vw_design_mobile} * 100vw);
		padding: rem(30) rem(16);

		&__container {
			flex-direction: column;
		}

		&__info {
			width: 100%;
			// margin-bottom: rem(20);
		}

		&__gallery {
			// flex-direction: row;
			// height: auto;
			// overflow-x: auto;
			// width: 100%;
			// padding-bottom: rem(10);
			gap: rem(10);

			&::-webkit-scrollbar {
				display: none;
			}
			scrollbar-width: none;
		}

		&__gallery-image {
			flex: 0 0 calc((100% - rem(20)) / 3);
			height: rem(156);

			&:last-child {
				margin-right: 0;
			}
		}
	}
}
</style> 